export * from './AboutModal';
//# sourceMappingURL=index.js.map